const communicationPreferences = ['Email', 'SMS'];
export default communicationPreferences;
